// New Shopify Integration - Simple Braze Tracking
(function () {
  const shopifyBase = "https://smartnursece.myshopify.com/";
  const learnBase = "https://learn.nursegrid.com/";
  const baseURL = window.location.href.startsWith(shopifyBase)
    ? shopifyBase
    : learnBase;
  const COOKIE_NAME = "ngbc";

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([.$?*|{}()\[\]\\/+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  function setNgcbCookie(value) {
    try {
      const expires = new Date(
        Date.now() + 365 * 24 * 60 * 60 * 1000
      ).toUTCString();
      document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/; Secure; SameSite=None`;
    } catch (e) {
    }
  }

  function extractFromUrl(prefix) {
    const urlWithoutParams = window.location.href.split("?")[0];
    if (!urlWithoutParams.startsWith(prefix)) return "";
    const urlPart = urlWithoutParams.slice(prefix.length);
    return urlPart.split("/")[0];
  }

  function setCustomAttribute(userObj, attributeName, value) {
    console.log("[Debug] Setting custom attribute:", attributeName, value);
    try {
      if (userObj && typeof userObj.addToCustomAttributeArray === "function") {
        const result = userObj.addToCustomAttributeArray(attributeName, value);
        if (braze && braze.requestImmediateDataFlush) {
          braze.requestImmediateDataFlush();
        }
        return result;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  function removeUtmParams(url) {
    const urlObj = new URL(url);
    urlObj.searchParams.forEach((value, key) => {
      if (key.startsWith("utm_")) {
        urlObj.searchParams.delete(key);
      }
    });
    return urlObj.toString();
  }

  function checkAndLogPageView() {
    if (typeof braze === "undefined" || !braze.isInitialized()) {
      return;
    }
    const cleanUrl = window.location.href;
    const userObj = braze.getUser();

    if (cleanUrl.includes(`${baseURL}products/`)) {
      const productName = extractFromUrl(`${baseURL}products/`);
      if (productName) {
        braze.logCustomEvent("viewed_product_page", { product: productName });
        if (userObj) {
          setCustomAttribute(userObj, "viewed_products_pages", productName);
        }
      }
    } else if (cleanUrl.includes(`${baseURL}collections/`)) {
      const collectionName = extractFromUrl(`${baseURL}collections/`);
      if (collectionName) {
        braze.logCustomEvent("viewed_collection_page", {
          collection: collectionName,
        });
        if (userObj) {
          setCustomAttribute(
            userObj,
            "viewed_collections_pages",
            collectionName
          );
        }
      }
    }

    if (braze.requestImmediateDataFlush) {
      braze.requestImmediateDataFlush();
    }
  }

  function getUserFromQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("user");
  }

  function waitForNewShopifyBraze(callback) {
    let attempts = 0;
    const maxAttempts = 100;
    const interval = 200;

    function check() {
      attempts++;
      if (
        typeof braze !== "undefined" &&
        typeof braze.isInitialized === "function" &&
        braze.isInitialized()
      ) {
        const userFromUrl = getUserFromQueryParam();
        if (userFromUrl) {
          setNgcbCookie(userFromUrl);
          braze.changeUser(userFromUrl);
        } else {
          const cookieUser = getCookie(COOKIE_NAME);
          if (cookieUser) {
            braze.changeUser(cookieUser);
          }
        }
        setTimeout(() => {
          callback();
        }, 500);
        return;
      }
      if (attempts < maxAttempts) {
        setTimeout(check, interval);
      } else {
        callback();
      }
    }

    check();
  }

  function initNewShopifyBraze() {
    waitForNewShopifyBraze(function () {
      checkAndLogPageView();
      document.addEventListener("page:load", checkAndLogPageView);
      document.addEventListener("turbolinks:load", checkAndLogPageView);
      window.addEventListener("popstate", checkAndLogPageView);
      window.addEventListener("hashchange", checkAndLogPageView);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNewShopifyBraze);
  } else {
    initNewShopifyBraze();
  }
})();